<template>
  <div class="flex flex-row items-center justify-between">
    <div class="flex flex-row items-center space-x-4">
      <slot name="icon">
        <component :is="icon.name || icon" class="h-6 w-6 text-gray-700 stroke-gray-700 " :class="icon.class" />
      </slot>
      <slot name="title">
        <p class="text-xl text-gray-700" :class="title.class" v-text="title.text || title" />
      </slot>
    </div>

    <slot></slot>

    <slot name="close">
      <button v-if="showCloseIcon"
        class="rounded-full p-2 transition duration-100 ease-in-out focus:border-blue-300 focus:outline-none hover:enabled:bg-cool-gray-200 disabled:opacity-50"
        :disabled="disabled" @click="$emit('modal:close', 'cancel')">
        <component :is="closeIcon.name" class="h-6 w-6 disabled:opacity-50" :class="closeIcon.class" />
      </button>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'ModalHeader',

  inject: ['modal'],

  props: {
    icon: {
      type: [String, Object],
      required: false,
      validator: (value) => typeof value === 'string' || 'name' in value,
      default: () => ({
        name: 'OutlineExclamationCircleIcon',
        class: 'text-cool-gray-500',
      }),
    },

    title: {
      type: [Object, String],
      required: true,
      validator: (value) => typeof value === 'string' || 'text' in value,
      default: () => ({
        text: 'Modal Title',
        class: '',
      }),
    },

    closeIcon: {
      type: Object,
      required: false,
      validator: (value) => 'name' in value,
      default: () => ({
        name: 'OutlineXIcon',
        class: 'text-gray-500',
      }),
    },
    disabled: { type: Boolean, required: false, default: false },
    showCloseIcon: { type: Boolean, required: false, default: true },
  },
}
</script>
